import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import styles from './AppShell.module.css'

export default function AppShell() {
    return (
        <div className={styles.shell}>
            <a href="#main" className={styles.skip}>Skip to content</a>
            <Header />
            <main id="main" className={styles.main}>
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}
